var render = function render(){var _vm=this,_c=_vm._self._c;return _c('clients-list',{attrs:{"add":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }